import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createPumpColumn, deletePumpColumn, getCapturePumpColumns, updatePumpColumn } from "../../api/captures/pumpColumn";
import { PumpColumnForm } from "../../types/forms/capture";

export const useCapturePumpColumn = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "pump-column"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCapturePumpColumns(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: PumpColumnForm) => createPumpColumn(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ columnId, values }: { columnId: number; values: PumpColumnForm }) => updatePumpColumn(captureId, columnId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (columnId: number) => deletePumpColumn(captureId, columnId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    pumpColumnsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createPumpColumn: createMutation.mutateAsync,
    updatePumpColumn: updateMutation.mutateAsync,
    deletePumpColumn: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
